import {
  all, call, put, select, takeEvery, takeLatest,
} from 'redux-saga/effects';
import { selectAuthUser } from 'base/auth/selectors';
import { IRestApiResponse } from '../../interfaces';
import { request } from '../../utils/request';
import API from './constants';
import { usersAction } from './slice';
import { GetUser, IEndUserProfileAction } from './interface';

export function* getUsersListGenerator({ payload }: GetUser): any {
  try {
    const expert = yield select(selectAuthUser);
    const response: IRestApiResponse = yield call(
      request,
      {
        path: `${API.GET_USERS.path}?expertId=${expert.id}&keyword=${payload.keyword}&page=${payload.page}&limit=${payload.limit}&sortBy=${payload.sortBy}`,
        method: API.GET_USERS.method,
      },
      {},
      true,
      false,
    );
    if (response.statusCode === 200) {
      yield put(usersAction.getUsersSucceeded(response.data));
    } else {
      yield put(usersAction.getUsersFailed());
    }
  } catch (error) {
    yield put(usersAction.getUsersFailed());
  }
}

export function* fetchUserProfileGenerator({ payload }: IEndUserProfileAction): any {
  try {
    const response: IRestApiResponse = yield call(
      request,
      {
        path: `${API.GET_FETCH_END_USER_PROFILE.path}/${payload}`,
        method: API.GET_FETCH_END_USER_PROFILE.method,
      },
      null,
      true,
    );
    if (response.statusCode === 200) {
      yield put(usersAction.fetchUserProfileSucceeded(response.data));
    } else {
      yield put(usersAction.fetchUserProfileFailed());
    }
  } catch (error) {
    yield put(usersAction.fetchUserProfileFailed());
  }
}

export function* usersSaga() {
  yield all([
    takeLatest(usersAction.getUsers.type, getUsersListGenerator),
    takeEvery(usersAction.fetchUserProfile.type, fetchUserProfileGenerator),
  ]);
}

export default usersSaga;
